export const POSTAL_CODE_MASK = /^\d{2}-\d{3}$/g;
